(() => {
  // Prevent double-loading if theme injects scripts oddly
  if (window.__obCustomFormLoaded) return;
  window.__obCustomFormLoaded = true;

  const COLOR_SELECT = 'select[name="options[Color]"]';
  const CUSTOM_PREFIX = 'custom'; // matches "Custom (+$10)" after normalize()

  const normalize = (v) =>
    (v ?? '')
      .toString()
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  const isCustomValue = (rawValue) => normalize(rawValue).startsWith(CUSTOM_PREFIX);

  const getColorValueFromSection = (sectionRoot) => {
    // 1) If it's a select dropdown
    const sel = sectionRoot.querySelector(COLOR_SELECT);
    if (sel) {
      const txt = sel.selectedOptions?.[0]?.textContent;
      return txt || sel.value || '';
    }

    // 2) If it's radio/button style (fieldset)
    // Look for a "Color" option group and then a checked/currentChecked input
    const fieldsets = Array.from(sectionRoot.querySelectorAll('fieldset'));
    const colorFs = fieldsets.find((fs) => {
      const legend = normalize(fs.querySelector('legend')?.textContent);
      return legend === 'color' || legend.startsWith('color');
    });

    if (colorFs) {
      const current = colorFs.querySelector('input[type="radio"][data-current-checked="true"]');
      const checked = colorFs.querySelector('input[type="radio"]:checked');
      const radio = current || checked;
      return radio?.value || radio?.getAttribute?.('value') || '';
    }

    // 3) Fallback: any checked radio with name containing Color
    const any =
      sectionRoot.querySelector('input[type="radio"][data-current-checked="true"][name*="Color"]') ||
      sectionRoot.querySelector('input[type="radio"]:checked[name*="Color"]');

    return any?.value || '';
  };

  const setVisibleForRoot = (root, isOn) => {
    const wrap = root.querySelector('.ob-custom-wrap');
    const notes = root.querySelector('.obCustomNotes');
    const reqTag = root.querySelector('.ob-required');
    if (!wrap || !notes) return;

    wrap.hidden = !isOn;

    // The whole bug you hit: required/validation must turn OFF when not custom
    notes.required = !!isOn;

    // Even safer: disable all custom inputs when not custom so they never block submit
    wrap.querySelectorAll('input, textarea, select').forEach((el) => {
      el.disabled = !isOn;
      if (!isOn) el.value = '';
    });

    if (reqTag) reqTag.hidden = !isOn;
  };

  const bindRoot = (root) => {
    if (!root || root.dataset.obCustomInit === '1') return;
    root.dataset.obCustomInit = '1';

    // Find the nearest product section to read option UI from (options may NOT be inside the form)
    const sectionRoot =
      root.closest('.shopify-section') ||
      root.closest('[data-section-id]') ||
      document;

    const sync = () => {
      const colorVal = getColorValueFromSection(sectionRoot);
      const isOn = isCustomValue(colorVal);
      setVisibleForRoot(root, isOn);
    };

    // Initial
    sync();

    // Listen for changes in selects/radios anywhere in the section
    sectionRoot.addEventListener(
      'change',
      () => {
        sync();
      },
      true
    );

    // Throttled mutation observer for theme "morphing" cases
    let raf = null;
    const scheduleSync = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        sync();
      });
    };

    const mo = new MutationObserver(scheduleSync);
    mo.observe(sectionRoot, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-current-checked', 'checked', 'value']
    });

    // Enforce required notes ONLY when Custom is on.
    // Use CAPTURE so we can stop bad submits early but not break normal ones.
    document.addEventListener(
      'submit',
      (ev) => {
        const form = ev.target;
        if (!form || form.tagName !== 'FORM') return;

        // Only handle the form inside this buy-buttons root
        if (!root.contains(form)) return;

        sync(); // ensure latest state

        const notes = root.querySelector('.obCustomNotes');
        const wrap = root.querySelector('.ob-custom-wrap');
        if (!notes || !wrap) return;

        const customIsOn = !wrap.hidden;

        if (customIsOn && !notes.value.trim()) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          notes.reportValidity();
          notes.focus();
        }
      },
      true
    );
  };

  const initAll = () => {
    document.querySelectorAll('.buy-buttons-block').forEach(bindRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // If theme loads sections dynamically, this catches it
  const pageMo = new MutationObserver(() => initAll());
  pageMo.observe(document.documentElement, { childList: true, subtree: true });
})();
